// // PopularProductsPage.jsx - Create this file in your pages folder

// import React, { useState, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { useLocation, useNavigate } from "react-router-dom";
// import Api from "../Utills/Api";
// import logo from "../../Frozenwala.png";
// import { 
//   FaHeart, 
//   FaSearch, 
//   FaArrowLeft, 
//   FaTh, 
//   FaThList,
//   FaShoppingCart,
//   FaStar,
//   FaFire
// } from "react-icons/fa";
// import { CiHeart } from "react-icons/ci";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import axios from "axios";
// import { useWishlist } from "../../contexts/WishlistContext";

// function PopularProductsPageAll() {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { wishlist, toggleWishlist, wishlistLoading } = useWishlist();
  
//   const [products, setProducts] = useState([]);
//   const [filteredProducts, setFilteredProducts] = useState([]);
//   const [cartItems, setCartItems] = useState({});
//   const [stock, setStock] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [sortOption, setSortOption] = useState("default");
//   const [viewMode, setViewMode] = useState("grid");

//   const uid = localStorage.getItem("user_id");
//   const isLoggedIn = localStorage.getItem("access_token");

//   useEffect(() => {
//     if (location.state?.products) {
//       setProducts(location.state.products);
//       setFilteredProducts(location.state.products);
//       fetchStockData();
//       fetchCartData();
//     } else {
//       fetchPopularProducts();
//     }
//   }, [location]);

//   const fetchPopularProducts = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch('https://backend.frozenwala.com/api/most-popular/');
//       const data = await response.json();
//       setProducts(Array.isArray(data) ? data : []);
//       setFilteredProducts(Array.isArray(data) ? data : []);
//       fetchStockData();
//       fetchCartData();
//     } catch (err) {
//       console.error("Error fetching popular products:", err);
//       toast.error("Failed to load popular products");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchStockData = async () => {
//     try {
//       const stockRes = await axios.get(`https://backend.frozenwala.com/api/stock/`);
//       const stockMap = {};
//       if (stockRes.data && Array.isArray(stockRes.data)) {
//         stockRes.data.forEach((item) => (stockMap[item.item_id] = item.openingstock));
//         setStock(stockMap);
//       }
//     } catch (stockErr) {
//       console.error("Error fetching stock data:", stockErr);
//     }
//   };

//   const fetchCartData = async () => {
//     if (isLoggedIn && uid) {
//       try {
//         const cartRes = await Api.get(`api/get_cart/?user_id=${uid}`);
//         const cartMap = {};
//         if (cartRes.data && Array.isArray(cartRes.data)) {
//           cartRes.data.forEach((item) => (cartMap[item.product_id] = item.quantity));
//           setCartItems(cartMap);
//         }
//       } catch (authError) {
//         console.log("User not logged in or token expired, skipping cart");
//       }
//     }
//   };

//   useEffect(() => {
//     let result = products;
    
//     if (searchTerm.trim()) {
//       result = result.filter(product => 
//         product.title.toLowerCase().includes(searchTerm.toLowerCase().trim())
//       );
//     }
    
//     if (sortOption === "price-low") {
//       result = [...result].sort((a, b) => a.item_new_price - b.item_new_price);
//     } else if (sortOption === "price-high") {
//       result = [...result].sort((a, b) => b.item_new_price - a.item_new_price);
//     } else if (sortOption === "discount") {
//       result = [...result].sort((a, b) => (b.discount_percentage || 0) - (a.discount_percentage || 0));
//     } else if (sortOption === "popular") {
//       result = [...result].sort((a, b) => (b.rating || 0) - (a.rating || 0));
//     } else {
//       result = [...result];
//     }
    
//     setFilteredProducts(result);
//   }, [searchTerm, sortOption, products]);

//   const onPressAddToCart = async (productId) => {
//     const accessToken = localStorage.getItem("access_token");
//     if (!accessToken) return navigate("/login");

//     try {
//       await Api.post(`api/add_to_cart/`, { product_id: productId, u_id: uid });
//       setCartItems((prev) => ({
//         ...prev,
//         [productId]: (prev[productId] || 0) + 1,
//       }));
//       toast.success("Added to cart!");
//     } catch (err) {
//       console.error("Add to cart failed:", err);
//       toast.error("Failed to add to cart");
//     }
//   };

//   const addOne = async (productId) => {
//     const accessToken = localStorage.getItem("access_token");
//     if (!accessToken) return navigate("/login");

//     const currentQty = cartItems[productId] || 0;
//     const available = stock[productId] || 0;

//     if (available > currentQty) {
//       try {
//         await Api.post(`api/increase/main/`, { product_id: productId, user_id: uid });
//         setCartItems((prev) => ({ ...prev, [productId]: currentQty + 1 }));
//         toast.success("Quantity updated");
//       } catch (err) {
//         console.error("Increase failed:", err);
//         toast.error("Failed to update quantity");
//       }
//     } else {
//       toast.warning(`Only ${available} items in stock`);
//     }
//   };

//   const subOne = async (productId) => {
//     const accessToken = localStorage.getItem("access_token");
//     if (!accessToken) return navigate("/login");

//     try {
//       await Api.post(`api/decrease/main/`, { product_id: productId, user_id: uid });
//       setCartItems((prev) => {
//         const updated = { ...prev };
//         if (updated[productId] > 1) updated[productId] -= 1;
//         else delete updated[productId];
//         return updated;
//       });
//     } catch (err) {
//       console.error("Decrease failed:", err);
//       toast.error("Failed to update quantity");
//     }
//   };

//   const styles = (
//     <style>{`
//       .popular-page {
//         min-height: 100vh;
//         background: #f5f7fa;
//         padding-bottom: 60px;
//       }

//       .page-header-popular {
//         background: #ffffff;
//         padding: 24px 0 20px;
//         border-bottom: 1px solid rgba(0, 0, 0, 0.06);
//         position: sticky;
//         top: 0;
//         z-index: 100;
//         backdrop-filter: blur(20px);
//         background: rgba(255, 255, 255, 0.92);
//       }

//       .page-header-inner-popular {
//         display: flex;
//         align-items: center;
//         justify-content: space-between;
//         flex-wrap: wrap;
//         gap: 16px;
//       }

//       .header-left-popular {
//         display: flex;
//         align-items: center;
//         gap: 16px;
//       }

//       .back-btn-popular {
//         display: flex;
//         align-items: center;
//         gap: 8px;
//         padding: 8px 16px;
//         border: none;
//         background: #f0f2f5;
//         border-radius: 12px;
//         color: #1a1a2e;
//         font-weight: 600;
//         font-size: 14px;
//         transition: all 0.25s ease;
//         cursor: pointer;
//         text-decoration: none;
//       }

//       .back-btn-popular:hover {
//         background: #e4e7ec;
//         transform: translateX(-2px);
//       }

//       .back-btn-popular svg {
//         font-size: 14px;
//       }

//       .header-title-group-popular {
//         display: flex;
//         flex-direction: column;
//       }

//       .page-title-popular {
//         font-size: 1.5rem;
//         font-weight: 800;
//         color: #1a1a2e;
//         letter-spacing: -0.3px;
//         margin: 0;
//         line-height: 1.2;
//       }

//       .page-title-popular .highlight {
//         background: linear-gradient(135deg, #5dc5fa, #ff8a4a);
//         -webkit-background-clip: text;
//         -webkit-text-fill-color: transparent;
//         background-clip: text;
//       }

//       .page-title-popular .star-icon {
//         display: inline-block;
//         animation: starPulse 2s infinite ease-in-out;
//       }

//       @keyframes starPulse {
//         0%, 100% { transform: scale(1) rotate(0deg); }
//         50% { transform: scale(1.2) rotate(10deg); }
//       }

//       .page-subtitle-popular {
//         font-size: 0.85rem;
//         color: #6b7280;
//         margin: 0;
//         font-weight: 500;
//       }

//       .page-subtitle-popular span {
//         font-weight: 700;
//         color: #5dc5fa;
//       }

//       .header-actions-popular {
//         display: flex;
//         align-items: center;
//         gap: 12px;
//       }

//       .header-stat-popular {
//         display: flex;
//         align-items: center;
//         gap: 6px;
//         padding: 6px 14px;
//         background: #f0f2f5;
//         border-radius: 50px;
//         font-size: 13px;
//         font-weight: 600;
//         color: #1a1a2e;
//       }

//       .header-stat-popular .count {
//         color: #5dc5fa;
//         font-weight: 800;
//         font-size: 15px;
//       }

//       .filter-bar-popular {
//         background: #ffffff;
//         border-radius: 16px;
//         padding: 16px 20px;
//         margin: 20px 0 28px;
//         box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
//         border: 1px solid rgba(0, 0, 0, 0.05);
//         display: flex;
//         flex-wrap: wrap;
//         align-items: center;
//         gap: 12px;
//       }

//       .search-wrapper-popular {
//         flex: 1;
//         min-width: 200px;
//         position: relative;
//       }

//       .search-icon-popular {
//         position: absolute;
//         left: 14px;
//         top: 50%;
//         transform: translateY(-50%);
//         color: #9ca3af;
//         font-size: 15px;
//       }

//       .search-input-popular {
//         width: 100%;
//         padding: 10px 16px 10px 44px;
//         border: 2px solid #e5e7eb;
//         border-radius: 12px;
//         font-size: 14px;
//         transition: all 0.3s ease;
//         background: #fafbfc;
//         color: #1a1a2e;
//         font-weight: 500;
//       }

//       .search-input-popular:focus {
//         border-color: #5dc5fa;
//         outline: none;
//         background: #ffffff;
//         box-shadow: 0 0 0 4px rgba(241, 114, 40, 0.08);
//       }

//       .search-input-popular::placeholder {
//         color: #9ca3af;
//         font-weight: 400;
//       }

//       .filter-controls-popular {
//         display: flex;
//         align-items: center;
//         gap: 10px;
//         flex-wrap: wrap;
//       }

//       .sort-select-popular {
//         padding: 10px 16px;
//         border: 2px solid #e5e7eb;
//         border-radius: 12px;
//         background: #fafbfc;
//         color: #1a1a2e;
//         font-size: 13px;
//         font-weight: 600;
//         cursor: pointer;
//         transition: all 0.3s ease;
//         min-width: 160px;
//         appearance: none;
//         background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236b7280' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
//         background-repeat: no-repeat;
//         background-position: right 14px center;
//         padding-right: 40px;
//       }

//       .sort-select-popular:focus {
//         border-color: #5dc5fa;
//         outline: none;
//         background-color: #ffffff;
//         box-shadow: 0 0 0 4px rgba(241, 114, 40, 0.08);
//       }

//       .view-toggle-popular {
//         display: flex;
//         gap: 4px;
//         background: #f0f2f5;
//         padding: 4px;
//         border-radius: 12px;
//         border: 1px solid #e5e7eb;
//       }

//       .view-toggle-btn-popular {
//         padding: 7px 14px;
//         border: none;
//         border-radius: 10px;
//         background: transparent;
//         color: #6b7280;
//         font-size: 13px;
//         font-weight: 600;
//         transition: all 0.25s ease;
//         cursor: pointer;
//         display: flex;
//         align-items: center;
//         gap: 6px;
//       }

//       .view-toggle-btn-popular.active {
//         background: #ffffff;
//         color: #5dc5fa;
//         box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
//       }

//       .view-toggle-btn-popular:hover:not(.active) {
//         color: #1a1a2e;
//       }

//       .view-toggle-btn-popular svg {
//         font-size: 14px;
//       }

//       .product-card-popular {
//         border-radius: 16px !important;
//         padding: 12px !important;
//         background: #ffffff !important;
//         border: 1px solid rgba(0, 0, 0, 0.05) !important;
//         box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
//         transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
//         height: 100%;
//         position: relative;
//       }

//       .product-card-popular:hover {
//         transform: translateY(-4px);
//         box-shadow: 0 12px 40px rgba(0, 0, 0, 0.08) !important;
//         border-color: rgba(241, 114, 40, 0.15) !important;
//       }

//       .product-image-frame-popular {
//         position: relative;
//         width: 100%;
//         height: 200px;
//         overflow: hidden;
//         border-radius: 12px !important;
//         background: #f8f9fb;
//       }

//       .product-image-popular {
//         width: 100%;
//         height: 100%;
//         object-fit: cover !important;
//         transition: transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
//       }

//       .product-card-popular:hover .product-image-popular {
//         transform: scale(1.05);
//       }

//       .rating-badge-popular {
//         position: absolute;
//         bottom: 10px;
//         left: 10px;
//         background: rgba(0, 0, 0, 0.7);
//         backdrop-filter: blur(8px);
//         color: white;
//         padding: 3px 12px;
//         border-radius: 50px;
//         font-size: 11px;
//         font-weight: 700;
//         z-index: 3;
//         display: flex;
//         align-items: center;
//         gap: 4px;
//       }

//       .rating-badge-popular svg {
//         color: #FFD700;
//         font-size: 12px;
//       }

//       .discount-badge-popular {
//         position: absolute;
//         top: 10px;
//         left: 10px;
//         background: linear-gradient(135deg, #ef4444, #dc2626);
//         color: white;
//         padding: 3px 12px;
//         border-radius: 50px;
//         font-size: 11px;
//         font-weight: 700;
//         z-index: 3;
//         letter-spacing: 0.3px;
//         box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
//       }

//       .sold-out-badge-popular {
//         position: absolute;
//         top: 10px;
//         left: 10px;
//         background: rgba(0, 0, 0, 0.7);
//         backdrop-filter: blur(8px);
//         color: white;
//         padding: 3px 12px;
//         border-radius: 50px;
//         font-size: 11px;
//         font-weight: 700;
//         z-index: 3;
//       }

//       .wishlist-btn-popular {
//         position: absolute;
//         top: 10px;
//         right: 10px;
//         background: rgba(255, 255, 255, 0.9);
//         backdrop-filter: blur(8px);
//         width: 34px;
//         height: 34px;
//         border-radius: 50%;
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         cursor: pointer;
//         z-index: 3;
//         transition: all 0.3s ease;
//         border: 1px solid rgba(0, 0, 0, 0.04);
//         box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
//       }

//       .wishlist-btn-popular:hover {
//         transform: scale(1.1);
//         background: #ffffff;
//         box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
//       }

//       .product-title-popular {
//         font-weight: 700;
//         color: #1a1a2e;
//         font-size: 14px;
//         cursor: pointer;
//         transition: color 0.2s ease;
//         display: -webkit-box;
//         -webkit-line-clamp: 2;
//         -webkit-box-orient: vertical;
//         overflow: hidden;
//         margin-bottom: 4px;
//         min-height: 40px;
//         line-height: 1.4;
//       }

//       .product-title-popular:hover {
//         color: #5dc5fa;
//       }

//       .product-meta-popular {
//         font-size: 12px;
//         color: #6b7280;
//         font-weight: 500;
//         margin-bottom: 8px;
//       }

//       .price-section-popular {
//         display: flex;
//         align-items: center;
//         flex-wrap: wrap;
//         gap: 8px;
//         margin-bottom: 12px;
//       }

//       .old-price-popular {
//         color: #9ca3af;
//         text-decoration: line-through;
//         font-size: 13px;
//         font-weight: 500;
//       }

//       .new-price-popular {
//         font-weight: 800;
//         color: #1a1a2e;
//         font-size: 18px;
//         letter-spacing: -0.2px;
//       }

//       .discount-text-popular {
//         color: #ef4444;
//         font-weight: 700;
//         font-size: 12px;
//         background: #fef2f2;
//         padding: 2px 10px;
//         border-radius: 50px;
//       }

//       .rating-text-popular {
//         color: #6b7280;
//         font-size: 12px;
//         font-weight: 500;
//         display: flex;
//         align-items: center;
//         gap: 4px;
//       }

//       .rating-text-popular svg {
//         color: #FFD700;
//       }

//       .add-to-cart-btn-popular {
//         background: linear-gradient(135deg, #5dc5fa, #5dc5fa);
//         color: white;
//         border: none;
//         padding: 10px 0;
//         border-radius: 12px;
//         font-weight: 700;
//         font-size: 13px;
//         width: 100%;
//         transition: all 0.3s ease;
//         box-shadow: 0 4px 16px rgba(241, 114, 40, 0.2);
//         cursor: pointer;
//         letter-spacing: 0.3px;
//       }

//       .add-to-cart-btn-popular:hover:not(:disabled) {
//         transform: translateY(-2px);
//         box-shadow: 0 6px 24px rgba(241, 114, 40, 0.3);
//       }

//       .add-to-cart-btn-popular:disabled {
//         opacity: 0.5;
//         cursor: not-allowed;
//         box-shadow: none;
//       }

//       .quantity-control-popular {
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         gap: 12px;
//         background: #f8f9fb;
//         padding: 4px;
//         border-radius: 12px;
//         border: 2px solid #e5e7eb;
//       }

//       .qty-btn-popular {
//         width: 30px;
//         height: 30px;
//         border-radius: 8px;
//         border: none;
//         background: white;
//         color: #1a1a2e;
//         font-weight: 700;
//         font-size: 16px;
//         cursor: pointer;
//         transition: all 0.2s ease;
//         box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
//         display: flex;
//         align-items: center;
//         justify-content: center;
//       }

//       .qty-btn-popular:hover {
//         background: #5dc5fa;
//         color: white;
//         transform: scale(1.05);
//       }

//       .qty-display-popular {
//         font-weight: 700;
//         font-size: 16px;
//         min-width: 24px;
//         text-align: center;
//         color: #1a1a2e;
//       }

//       .empty-state-popular {
//         text-align: center;
//         padding: 80px 20px;
//         background: white;
//         border-radius: 16px;
//         border: 1px solid rgba(0, 0, 0, 0.05);
//       }

//       .empty-state-popular .icon {
//         font-size: 56px;
//         display: block;
//         margin-bottom: 16px;
//       }

//       /* List view */
//       .list-view .product-card-popular {
//         display: flex;
//         flex-direction: row;
//         align-items: center;
//         padding: 16px !important;
//       }

//       .list-view .product-image-frame-popular {
//         width: 160px;
//         min-width: 160px;
//         height: 140px;
//         margin-right: 20px;
//       }

//       .list-view .card-body {
//         flex: 1;
//         display: flex;
//         flex-direction: row;
//         align-items: center;
//         flex-wrap: wrap;
//         gap: 16px;
//         padding: 0 !important;
//       }

//       .list-view .product-info {
//         flex: 1;
//         min-width: 180px;
//       }

//       .list-view .action-section {
//         min-width: 140px;
//       }

//       @media (max-width: 768px) {
//         .page-header-inner-popular {
//           flex-direction: column;
//           align-items: stretch;
//         }

//         .header-left-popular {
//           flex-wrap: wrap;
//         }

//         .header-actions-popular {
//           justify-content: space-between;
//           width: 100%;
//         }

//         .filter-bar-popular {
//           flex-direction: column;
//           align-items: stretch;
//           padding: 14px 16px;
//         }

//         .search-wrapper-popular {
//           min-width: unset;
//         }

//         .filter-controls-popular {
//           flex-wrap: wrap;
//           justify-content: space-between;
//         }

//         .sort-select-popular {
//           min-width: unset;
//           flex: 1;
//         }

//         .view-toggle-popular {
//           align-self: flex-start;
//         }

//         .list-view .product-card-popular {
//           flex-direction: column;
//           align-items: stretch;
//         }

//         .list-view .product-image-frame-popular {
//           width: 100%;
//           min-width: unset;
//           height: 170px;
//           margin-right: 0;
//           margin-bottom: 12px;
//         }

//         .list-view .card-body {
//           flex-direction: column;
//           align-items: stretch;
//         }

//         .list-view .product-info {
//           min-width: unset;
//         }

//         .list-view .action-section {
//           min-width: unset;
//         }
//       }

//       @media (max-width: 575.98px) {
//         .page-title-popular {
//           font-size: 1.2rem;
//         }

//         .page-header-popular {
//           padding: 16px 0 14px;
//         }

//         .filter-bar-popular {
//           padding: 12px 14px;
//           border-radius: 12px;
//           margin: 12px 0 20px;
//         }

//         .product-image-frame-popular {
//           height: 160px;
//         }

//         .product-title-popular {
//           font-size: 13px;
//           min-height: 36px;
//         }

//         .new-price-popular {
//           font-size: 16px;
//         }

//         .product-card-popular {
//           padding: 10px !important;
//         }

//         .header-stat-popular {
//           font-size: 12px;
//           padding: 4px 12px;
//         }

//         .back-btn-popular {
//           padding: 6px 12px;
//           font-size: 13px;
//         }

//         .filter-controls-popular {
//           flex-direction: column;
//           align-items: stretch;
//         }

//         .sort-select-popular {
//           width: 100%;
//         }

//         .view-toggle-popular {
//           align-self: center;
//         }

//         .list-view .product-image-frame-popular {
//           height: 140px;
//         }
//       }

//       @media (max-width: 400px) {
//         .product-image-frame-popular {
//           height: 130px;
//         }
//       }
//     `}</style>
//   );

//   if (loading) {
//     return (
//       <div className="popular-page">
//         {styles}
//         <div className="page-header-popular">
//           <div className="container">
//             <div className="page-header-inner-popular">
//               <div className="header-left-popular">
//                 <div className="header-title-group-popular">
//                   <h1 className="page-title-popular">
//                     <span className="star-icon">⭐</span> Popular <span className="highlight">Products</span>
//                   </h1>
//                   <p className="page-subtitle-popular">Loading popular products...</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="container">
//           <div className="text-center py-5">
//             <div className="spinner-border text-warning" role="status" style={{ width: "40px", height: "40px" }}>
//               <span className="visually-hidden">Loading...</span>
//             </div>
//             <p className="mt-3 text-muted" style={{ fontSize: "14px" }}>Loading products...</p>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="popular-page">
//       {styles}

//       {/* Modern Clean Header */}
//       <div className="page-header-popular">
//         <div className="container">
//           <div className="page-header-inner-popular">
//             <div className="header-left-popular">
//               <button className="back-btn-popular" onClick={() => navigate(-1)}>
//                 <FaArrowLeft /> Back
//               </button>
              
//               <div className="header-title-group-popular">
//                 <motion.h1 
//                   className="page-title-popular"
//                   initial={{ opacity: 0, y: -10 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.4 }}
//                 >
//                   <span className="star-icon">⭐</span> Popular <span className="highlight">Products</span>
//                 </motion.h1>
//                 <motion.p 
//                   className="page-subtitle-popular"
//                   initial={{ opacity: 0, y: -5 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.4, delay: 0.1 }}
//                 >
//                   <span>{filteredProducts.length}</span> {filteredProducts.length === 1 ? 'product' : 'products'} found
//                 </motion.p>
//               </div>
//             </div>

            
//           </div>
//         </div>
//       </div>

//       <div className="container">
//         {/* Modern Filter Bar */}
//         <motion.div 
//           className="filter-bar-popular"
//           initial={{ opacity: 0, y: 10 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.4, delay: 0.2 }}
//         >
//           <div className="search-wrapper-popular">
//             <FaSearch className="search-icon-popular" />
//             <input
//               type="text"
//               className="search-input-popular"
//               placeholder="Search popular products..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//           </div>
          
//           <div className="filter-controls-popular">
//             <select
//               className="sort-select-popular"
//               value={sortOption}
//               onChange={(e) => setSortOption(e.target.value)}
//             >
//               <option value="default">Sort: Default</option>
//               <option value="popular">Sort: Most Popular</option>
//               <option value="price-low">Price: Low → High</option>
//               <option value="price-high">Price: High → Low</option>
//               <option value="discount">Discount: High → Low</option>
//             </select>

//             <div className="view-toggle-popular">
//               <button 
//                 className={`view-toggle-btn-popular ${viewMode === 'grid' ? 'active' : ''}`}
//                 onClick={() => setViewMode('grid')}
//               >
//                 <FaTh /> Grid
//               </button>
//               <button 
//                 className={`view-toggle-btn-popular ${viewMode === 'list' ? 'active' : ''}`}
//                 onClick={() => setViewMode('list')}
//               >
//                 <FaThList /> List
//               </button>
//             </div>
//           </div>
//         </motion.div>

//         {/* Products Grid */}
//         {filteredProducts.length === 0 ? (
//           <motion.div 
//             className="empty-state-popular"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//           >
//             <span className="icon">🔍</span>
//             <h4 style={{ color: '#1a1a2e', fontWeight: 700 }}>No products found</h4>
//             <p style={{ color: '#6b7280' }}>Try adjusting your search or filters</p>
//           </motion.div>
//         ) : (
//           <motion.div 
//             className={`row gy-4 ${viewMode === 'list' ? 'list-view' : ''}`}
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             transition={{ duration: 0.5 }}
//           >
//             <AnimatePresence>
//               {filteredProducts.map((item, index) => {
//                 const isSoldOut = item.stock === 0;
//                 const isInWishlist = wishlist.some((w) => w && w.item && w.item.id === item.id);
//                 const cartQty = cartItems[item.id];
//                 const discount = item.discount_percentage || 0;
//                 const rating = item.rating || 4.6;

//                 return (
//                   <motion.div
//                     key={item.id}
//                     className={viewMode === 'grid' ? 'col-6 col-sm-6 col-md-4 col-lg-3' : 'col-12'}
//                     initial={{ opacity: 0, y: 20 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     exit={{ opacity: 0, scale: 0.95 }}
//                     transition={{ duration: 0.3, delay: index * 0.03 }}
//                   >
//                     <div className="card border-0 product-card-popular">
//                       <div className="product-image-frame-popular">
                      
                        
//                         <button
//                           className="wishlist-btn-popular"
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             if (!wishlistLoading) toggleWishlist(item);
//                           }}
//                         >
//                           {isInWishlist ? (
//                             <FaHeart size={16} color="#5dc5fa" />
//                           ) : (
//                             <CiHeart size={18} color="#6b7280" />
//                           )}
//                         </button>

//                         <img
//                           src={item.item_photo || logo}
//                           alt={item.title}
//                           className="product-image-popular"
//                           style={{ cursor: "pointer" }}
//                           onClick={() => navigate(`/products/${item.id}`)}
//                         />
//                       </div>

//                       <div className="card-body d-flex flex-column p-2 pt-3">
//                         <div className={viewMode === 'list' ? 'card-body-inner d-flex flex-wrap gap-3' : ''}>
//                           <div className={viewMode === 'list' ? 'product-info' : ''}>
//                             <h6 
//                               className="product-title-popular"
//                               onClick={() => navigate(`/products/${item.id}`)}
//                             >
//                               {item.title}
//                             </h6>
                            
//                             {item.brand && (
//                               <div className="product-meta-popular">{item.brand}</div>
//                             )}

//                             <div className="price-section-popular">
//                               {item.item_old_price > item.item_new_price && (
//                                 <span className="old-price-popular">₹{item.item_old_price}</span>
//                               )}
//                               <span className="new-price-popular">₹{item.item_new_price}</span>
//                               {discount > 0 && (
//                                 <span className="discount-text-popular">{discount}% OFF</span>
//                               )}
//                             </div>
                            
//                             <div className="rating-text-popular">
//                               <FaStar /> {rating} ({Math.floor(Math.random() * 100) + 50} reviews)
//                             </div>
//                           </div>

//                           <div className={viewMode === 'list' ? 'action-section' : 'mt-auto w-100'}>
//                             {cartQty && !isSoldOut && isLoggedIn ? (
//                               <div className="quantity-control-popular">
//                                 <button 
//                                   className="qty-btn-popular"
//                                   onClick={() => subOne(item.id)}
//                                 >
//                                   −
//                                 </button>
//                                 <span className="qty-display-popular">{cartQty}</span>
//                                 <button 
//                                   className="qty-btn-popular"
//                                   onClick={() => addOne(item.id)}
//                                 >
//                                   +
//                                 </button>
//                               </div>
//                             ) : (
//                               <button
//                                 className="add-to-cart-btn-popular"
//                                 onClick={() => onPressAddToCart(item.id)}
//                                 disabled={isSoldOut}
//                               >
//                                 {isSoldOut ? 'Out of Stock' : 'Add to Cart'}
//                               </button>
//                             )}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </motion.div>
//                 );
//               })}
//             </AnimatePresence>
//           </motion.div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default PopularProductsPageAll;

// PopularProductsPage.jsx - Create this file in your pages folder

import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";
import Api from "../Utills/Api";
import logo from "../../Frozenwala.png";
import { 
  FaHeart, 
  FaSearch, 
  FaArrowLeft, 
  FaTh, 
  FaThList,
  FaShoppingCart,
  FaStar,
  FaFire
} from "react-icons/fa";
import { CiHeart } from "react-icons/ci";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useWishlist } from "../../contexts/WishlistContext";

function PopularProductsPageAll() {
  const location = useLocation();
  const navigate = useNavigate();
  const { wishlist, toggleWishlist, wishlistLoading } = useWishlist();
  
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [cartItems, setCartItems] = useState({});
  const [stock, setStock] = useState({});
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOption, setSortOption] = useState("default");
  const [viewMode, setViewMode] = useState("grid");

  const uid = localStorage.getItem("user_id");
  const isLoggedIn = localStorage.getItem("access_token");

  useEffect(() => {
    if (location.state?.products) {
      setProducts(location.state.products);
      setFilteredProducts(location.state.products);
      fetchStockData();
      fetchCartData();
    } else {
      fetchPopularProducts();
    }
  }, [location]);

  const fetchPopularProducts = async () => {
    try {
      setLoading(true);
      const response = await fetch('https://backend.frozenwala.com/api/most-popular/');
      const data = await response.json();
      setProducts(Array.isArray(data) ? data : []);
      setFilteredProducts(Array.isArray(data) ? data : []);
      fetchStockData();
      fetchCartData();
    } catch (err) {
      console.error("Error fetching popular products:", err);
      toast.error("Failed to load popular products");
    } finally {
      setLoading(false);
    }
  };

  const fetchStockData = async () => {
    try {
      const stockRes = await axios.get(`https://backend.frozenwala.com/api/stock/`);
      const stockMap = {};
      if (stockRes.data && Array.isArray(stockRes.data)) {
        stockRes.data.forEach((item) => (stockMap[item.item_id] = item.openingstock));
        setStock(stockMap);
      }
    } catch (stockErr) {
      console.error("Error fetching stock data:", stockErr);
    }
  };

  const fetchCartData = async () => {
    if (isLoggedIn && uid) {
      try {
        const cartRes = await Api.get(`api/get_cart/?user_id=${uid}`);
        const cartMap = {};
        if (cartRes.data && Array.isArray(cartRes.data)) {
          cartRes.data.forEach((item) => (cartMap[item.product_id] = item.quantity));
          setCartItems(cartMap);
        }
      } catch (authError) {
        console.log("User not logged in or token expired, skipping cart");
      }
    }
  };

  useEffect(() => {
    let result = products;
    
    if (searchTerm.trim()) {
      result = result.filter(product => 
        product.title.toLowerCase().includes(searchTerm.toLowerCase().trim())
      );
    }
    
    if (sortOption === "price-low") {
      result = [...result].sort((a, b) => a.item_new_price - b.item_new_price);
    } else if (sortOption === "price-high") {
      result = [...result].sort((a, b) => b.item_new_price - a.item_new_price);
    } else if (sortOption === "discount") {
      result = [...result].sort((a, b) => (b.discount_percentage || 0) - (a.discount_percentage || 0));
    } else if (sortOption === "popular") {
      result = [...result].sort((a, b) => (b.rating || 0) - (a.rating || 0));
    } else {
      result = [...result];
    }
    
    setFilteredProducts(result);
  }, [searchTerm, sortOption, products]);

  const onPressAddToCart = async (productId) => {
    const accessToken = localStorage.getItem("access_token");
    if (!accessToken) return navigate("/login");

    try {
      await Api.post(`api/add_to_cart/`, { product_id: productId, u_id: uid });
      setCartItems((prev) => ({
        ...prev,
        [productId]: (prev[productId] || 0) + 1,
      }));
      toast.success("Added to cart!");
    } catch (err) {
      console.error("Add to cart failed:", err);
      toast.error("Failed to add to cart");
    }
  };

  const addOne = async (productId) => {
    const accessToken = localStorage.getItem("access_token");
    if (!accessToken) return navigate("/login");

    const currentQty = cartItems[productId] || 0;
    const available = stock[productId] || 0;

    if (available > currentQty) {
      try {
        await Api.post(`api/increase/main/`, { product_id: productId, user_id: uid });
        setCartItems((prev) => ({ ...prev, [productId]: currentQty + 1 }));
        toast.success("Quantity updated");
      } catch (err) {
        console.error("Increase failed:", err);
        toast.error("Failed to update quantity");
      }
    } else {
      toast.warning(`Only ${available} items in stock`);
    }
  };

  const subOne = async (productId) => {
    const accessToken = localStorage.getItem("access_token");
    if (!accessToken) return navigate("/login");

    try {
      await Api.post(`api/decrease/main/`, { product_id: productId, user_id: uid });
      setCartItems((prev) => {
        const updated = { ...prev };
        if (updated[productId] > 1) updated[productId] -= 1;
        else delete updated[productId];
        return updated;
      });
    } catch (err) {
      console.error("Decrease failed:", err);
      toast.error("Failed to update quantity");
    }
  };

  const styles = (
    <style>{`
      .popular-page {
        min-height: 100vh;
        background: #f5f7fa;
        padding-bottom: 60px;
      }

      .page-header-popular {
        background: #ffffff;
        padding: 24px 0 20px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
        position: sticky;
        top: 0;
        z-index: 100;
        backdrop-filter: blur(20px);
        background: rgba(255, 255, 255, 0.92);
      }

      .page-header-inner-popular {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 16px;
      }

      .header-left-popular {
        display: flex;
        align-items: center;
        gap: 16px;
      }

      .back-btn-popular {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 16px;
        border: none;
        background: #f0f2f5;
        border-radius: 12px;
        color: #1a1a2e;
        font-weight: 600;
        font-size: 14px;
        transition: all 0.25s ease;
        cursor: pointer;
        text-decoration: none;
      }

      .back-btn-popular:hover {
        background: #e4e7ec;
        transform: translateX(-2px);
      }

      .back-btn-popular svg {
        font-size: 14px;
      }

      .header-title-group-popular {
        display: flex;
        flex-direction: column;
      }

      .page-title-popular {
        font-size: 1.5rem;
        font-weight: 800;
        color: #1a1a2e;
        letter-spacing: -0.3px;
        margin: 0;
        line-height: 1.2;
      }

      .page-title-popular .highlight {
        background: linear-gradient(135deg, #5dc5fa, #ff8a4a);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }

      .page-title-popular .star-icon {
        display: inline-block;
        animation: starPulse 2s infinite ease-in-out;
      }

      @keyframes starPulse {
        0%, 100% { transform: scale(1) rotate(0deg); }
        50% { transform: scale(1.2) rotate(10deg); }
      }

      .page-subtitle-popular {
        font-size: 0.85rem;
        color: #6b7280;
        margin: 0;
        font-weight: 500;
      }

      .page-subtitle-popular span {
        font-weight: 700;
        color: #5dc5fa;
      }

      .header-actions-popular {
        display: flex;
        align-items: center;
        gap: 12px;
      }

      .header-stat-popular {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 6px 14px;
        background: #f0f2f5;
        border-radius: 50px;
        font-size: 13px;
        font-weight: 600;
        color: #1a1a2e;
      }

      .header-stat-popular .count {
        color: #5dc5fa;
        font-weight: 800;
        font-size: 15px;
      }

      .filter-bar-popular {
        background: #ffffff;
        border-radius: 16px;
        padding: 16px 20px;
        margin: 20px 0 28px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
        border: 1px solid rgba(0, 0, 0, 0.05);
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 12px;
      }

      .search-wrapper-popular {
        flex: 1;
        min-width: 200px;
        position: relative;
      }

      .search-icon-popular {
        position: absolute;
        left: 14px;
        top: 50%;
        transform: translateY(-50%);
        color: #9ca3af;
        font-size: 15px;
      }

      .search-input-popular {
        width: 100%;
        padding: 10px 16px 10px 44px;
        border: 2px solid #e5e7eb;
        border-radius: 12px;
        font-size: 14px;
        transition: all 0.3s ease;
        background: #fafbfc;
        color: #1a1a2e;
        font-weight: 500;
      }

      .search-input-popular:focus {
        border-color: #5dc5fa;
        outline: none;
        background: #ffffff;
        box-shadow: 0 0 0 4px rgba(241, 114, 40, 0.08);
      }

      .search-input-popular::placeholder {
        color: #9ca3af;
        font-weight: 400;
      }

      .filter-controls-popular {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-wrap: wrap;
      }

      .sort-select-popular {
        padding: 10px 16px;
        border: 2px solid #e5e7eb;
        border-radius: 12px;
        background: #fafbfc;
        color: #1a1a2e;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
        min-width: 160px;
        appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236b7280' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 14px center;
        padding-right: 40px;
      }

      .sort-select-popular:focus {
        border-color: #5dc5fa;
        outline: none;
        background-color: #ffffff;
        box-shadow: 0 0 0 4px rgba(241, 114, 40, 0.08);
      }

      .view-toggle-popular {
        display: flex;
        gap: 4px;
        background: #f0f2f5;
        padding: 4px;
        border-radius: 12px;
        border: 1px solid #e5e7eb;
      }

      .view-toggle-btn-popular {
        padding: 7px 14px;
        border: none;
        border-radius: 10px;
        background: transparent;
        color: #6b7280;
        font-size: 13px;
        font-weight: 600;
        transition: all 0.25s ease;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 6px;
      }

      .view-toggle-btn-popular.active {
        background: #ffffff;
        color: #5dc5fa;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      }

      .view-toggle-btn-popular:hover:not(.active) {
        color: #1a1a2e;
      }

      .view-toggle-btn-popular svg {
        font-size: 14px;
      }

      .product-card-popular {
        border-radius: 16px !important;
        padding: 12px !important;
        background: #ffffff !important;
        border: 1px solid rgba(0, 0, 0, 0.05) !important;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
        transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
        height: 100%;
        position: relative;
      }

      .product-card-popular:hover {
        transform: translateY(-4px);
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.08) !important;
        border-color: rgba(241, 114, 40, 0.15) !important;
      }

      .product-image-frame-popular {
        position: relative;
        width: 100%;
        height: 200px;
        overflow: hidden;
        border-radius: 12px !important;
        background: #f8f9fb;
      }

      .product-image-popular {
        width: 100%;
        height: 100%;
        object-fit: cover !important;
        transition: transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
      }

      .product-card-popular:hover .product-image-popular {
        transform: scale(1.05);
      }

      .rating-badge-popular {
        position: absolute;
        bottom: 10px;
        left: 10px;
        background: rgba(0, 0, 0, 0.7);
        backdrop-filter: blur(8px);
        color: white;
        padding: 3px 12px;
        border-radius: 50px;
        font-size: 11px;
        font-weight: 700;
        z-index: 3;
        display: flex;
        align-items: center;
        gap: 4px;
      }

      .rating-badge-popular svg {
        color: #FFD700;
        font-size: 12px;
      }

      .discount-badge-popular {
        position: absolute;
        top: 10px;
        left: 10px;
        background: linear-gradient(135deg, #ef4444, #dc2626);
        color: white;
        padding: 3px 12px;
        border-radius: 50px;
        font-size: 11px;
        font-weight: 700;
        z-index: 3;
        letter-spacing: 0.3px;
        box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
      }

      .sold-out-badge-popular {
        position: absolute;
        top: 10px;
        left: 10px;
        background: rgba(0, 0, 0, 0.7);
        backdrop-filter: blur(8px);
        color: white;
        padding: 3px 12px;
        border-radius: 50px;
        font-size: 11px;
        font-weight: 700;
        z-index: 3;
      }

      .wishlist-btn-popular {
        position: absolute;
        top: 10px;
        right: 10px;
        background: rgba(255, 255, 255, 0.9);
        backdrop-filter: blur(8px);
        width: 34px;
        height: 34px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 3;
        transition: all 0.3s ease;
        border: 1px solid rgba(0, 0, 0, 0.04);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      }

      .wishlist-btn-popular:hover {
        transform: scale(1.1);
        background: #ffffff;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
      }

      .product-title-popular {
        font-weight: 700;
        color: #1a1a2e;
        font-size: 14px;
        cursor: pointer;
        transition: color 0.2s ease;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin-bottom: 4px;
        min-height: 40px;
        max-height: 40px;
        line-height: 1.4;
        word-break: break-word;
      }

      .product-title-popular:hover {
        color: #5dc5fa;
      }

      .product-meta-popular {
        font-size: 12px;
        color: #6b7280;
        font-weight: 500;
        margin-bottom: 8px;
        min-height: 16px; /* reserve space even when brand is absent, so title/price block is always the same height */
      }

      .price-section-popular {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;
        margin-bottom: 12px;
      }

      .old-price-popular {
        color: #9ca3af;
        text-decoration: line-through;
        font-size: 13px;
        font-weight: 500;
      }

      .new-price-popular {
        font-weight: 800;
        color: #1a1a2e;
        font-size: 18px;
        letter-spacing: -0.2px;
      }

      .discount-text-popular {
        color: #ef4444;
        font-weight: 700;
        font-size: 12px;
        background: #fef2f2;
        padding: 2px 10px;
        border-radius: 50px;
      }

      .rating-text-popular {
        color: #6b7280;
        font-size: 12px;
        font-weight: 500;
        display: flex;
        align-items: center;
        gap: 4px;
      }

      .rating-text-popular svg {
        color: #FFD700;
      }

      .add-to-cart-btn-popular {
        background: linear-gradient(135deg, #5dc5fa, #5dc5fa);
        color: white;
        border: none;
        padding: 10px 0;
        border-radius: 12px;
        font-weight: 700;
        font-size: 13px;
        width: 100%;
        transition: all 0.3s ease;
        box-shadow: 0 4px 16px rgba(241, 114, 40, 0.2);
        cursor: pointer;
        letter-spacing: 0.3px;
        text-align: center;
      }

      .add-to-cart-btn-popular:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 6px 24px rgba(241, 114, 40, 0.3);
      }

      .add-to-cart-btn-popular:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        box-shadow: none;
      }

      .quantity-control-popular {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        background: #f8f9fb;
        padding: 4px;
        border-radius: 12px;
        border: 2px solid #e5e7eb;
        width: 100%;
      }

      .qty-btn-popular {
        width: 30px;
        height: 30px;
        border-radius: 8px;
        border: none;
        background: white;
        color: #1a1a2e;
        font-weight: 700;
        font-size: 16px;
        cursor: pointer;
        transition: all 0.2s ease;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .qty-btn-popular:hover {
        background: #5dc5fa;
        color: white;
        transform: scale(1.05);
      }

      .qty-display-popular {
        font-weight: 700;
        font-size: 16px;
        min-width: 24px;
        text-align: center;
        color: #1a1a2e;
      }

      .empty-state-popular {
        text-align: center;
        padding: 80px 20px;
        background: white;
        border-radius: 16px;
        border: 1px solid rgba(0, 0, 0, 0.05);
      }

      .empty-state-popular .icon {
        font-size: 56px;
        display: block;
        margin-bottom: 16px;
      }

      /* List view */
      .list-view .product-card-popular {
        display: flex;
        flex-direction: row;
        align-items: stretch;
        padding: 16px !important;
        gap: 20px;
      }

      .list-view .product-image-frame-popular {
        width: 160px;
        min-width: 160px;
        height: 160px;
        flex-shrink: 0;
      }

      /* card-body now stretches to the fixed image height instead of
         hugging its own content and being re-centered — this is what
         kept moving the Add to Cart button around between cards. */
      .list-view .card-body {
        flex: 1;
        display: flex;
        flex-direction: row;
        align-items: stretch;
        justify-content: space-between;
        padding: 0 !important;
        gap: 20px;
        width: 100%;
        height: 100%;
      }

      .list-view .card-body-inner {
        display: flex;
        flex-wrap: nowrap;
        align-items: stretch;
        width: 100%;
        height: 100%;
        gap: 20px;
      }

      .list-view .product-info {
        flex: 1;
        min-width: 180px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
      }

      .list-view .action-section {
        min-width: 160px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
      }

      .list-view .action-section .add-to-cart-btn-popular,
      .list-view .action-section .quantity-control-popular {
        width: 100%;
        max-width: 200px;
      }

      .list-view .product-title-popular {
        min-height: 40px;
        max-height: 40px;
        font-size: 15px;
      }

      .list-view .price-section-popular {
        margin-bottom: 8px;
      }

      @media (max-width: 768px) {
        .page-header-inner-popular {
          flex-direction: column;
          align-items: stretch;
        }

        .header-left-popular {
          flex-wrap: wrap;
        }

        .header-actions-popular {
          justify-content: space-between;
          width: 100%;
        }

        .filter-bar-popular {
          flex-direction: column;
          align-items: stretch;
          padding: 14px 16px;
        }

        .search-wrapper-popular {
          min-width: unset;
        }

        .filter-controls-popular {
          flex-wrap: wrap;
          justify-content: space-between;
        }

        .sort-select-popular {
          min-width: unset;
          flex: 1;
        }

        .view-toggle-popular {
          align-self: flex-start;
        }

        .list-view .product-card-popular {
          flex-direction: column;
          align-items: stretch;
        }

        .list-view .product-image-frame-popular {
          width: 100%;
          min-width: unset;
          height: 170px;
          flex-shrink: 0;
        }

        .list-view .card-body,
        .list-view .card-body-inner {
          flex-direction: column;
          align-items: stretch;
          height: auto;
          gap: 12px;
        }

        .list-view .product-info {
          min-width: unset;
          height: auto;
        }

        .list-view .action-section {
          min-width: unset;
          width: 100%;
          height: auto;
        }

        .list-view .action-section .add-to-cart-btn-popular,
        .list-view .action-section .quantity-control-popular {
          max-width: 100%;
        }
      }

      @media (max-width: 575.98px) {
        .page-title-popular {
          font-size: 1.2rem;
        }

        .page-header-popular {
          padding: 16px 0 14px;
        }

        .filter-bar-popular {
          padding: 12px 14px;
          border-radius: 12px;
          margin: 12px 0 20px;
        }

        .product-image-frame-popular {
          height: 160px;
        }

        .product-title-popular {
          font-size: 13px;
          min-height: 36px;
          max-height: 36px;
        }

        .new-price-popular {
          font-size: 16px;
        }

        .product-card-popular {
          padding: 10px !important;
        }

        .header-stat-popular {
          font-size: 12px;
          padding: 4px 12px;
        }

        .back-btn-popular {
          padding: 6px 12px;
          font-size: 13px;
        }

        .filter-controls-popular {
          flex-direction: column;
          align-items: stretch;
        }

        .sort-select-popular {
          width: 100%;
        }

        .view-toggle-popular {
          align-self: center;
        }

        .list-view .product-image-frame-popular {
          height: 140px;
        }

        .list-view .product-title-popular {
          min-height: 36px;
          max-height: 36px;
          font-size: 14px;
        }
      }

      @media (max-width: 400px) {
        .product-image-frame-popular {
          height: 130px;
        }

        .list-view .product-image-frame-popular {
          height: 120px;
        }
      }
    `}</style>
  );

  if (loading) {
    return (
      <div className="popular-page">
        {styles}
        <div className="page-header-popular">
          <div className="container">
            <div className="page-header-inner-popular">
              <div className="header-left-popular">
                <div className="header-title-group-popular">
                  <h1 className="page-title-popular">
                    <span className="star-icon">⭐</span> Popular <span className="highlight">Products</span>
                  </h1>
                  <p className="page-subtitle-popular">Loading popular products...</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="text-center py-5">
            <div className="spinner-border text-warning" role="status" style={{ width: "40px", height: "40px" }}>
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3 text-muted" style={{ fontSize: "14px" }}>Loading products...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="popular-page">
      {styles}

      {/* Modern Clean Header */}
      <div className="page-header-popular">
        <div className="container">
          <div className="page-header-inner-popular">
            <div className="header-left-popular">
              <button className="back-btn-popular" onClick={() => navigate(-1)}>
                <FaArrowLeft /> Back
              </button>
              
              <div className="header-title-group-popular">
                <motion.h1 
                  className="page-title-popular"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  <span className="star-icon">⭐</span> Popular <span className="highlight">Products</span>
                </motion.h1>
                <motion.p 
                  className="page-subtitle-popular"
                  initial={{ opacity: 0, y: -5 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: 0.1 }}
                >
                  <span>{filteredProducts.length}</span> {filteredProducts.length === 1 ? 'product' : 'products'} found
                </motion.p>
              </div>
            </div>

            
          </div>
        </div>
      </div>

      <div className="container">
        {/* Modern Filter Bar */}
        <motion.div 
          className="filter-bar-popular"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.2 }}
        >
          <div className="search-wrapper-popular">
            <FaSearch className="search-icon-popular" />
            <input
              type="text"
              className="search-input-popular"
              placeholder="Search popular products..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          
          <div className="filter-controls-popular">
            <select
              className="sort-select-popular"
              value={sortOption}
              onChange={(e) => setSortOption(e.target.value)}
            >
              <option value="default">Sort: Default</option>
              <option value="popular">Sort: Most Popular</option>
              <option value="price-low">Price: Low → High</option>
              <option value="price-high">Price: High → Low</option>
              <option value="discount">Discount: High → Low</option>
            </select>

            <div className="view-toggle-popular">
              <button 
                className={`view-toggle-btn-popular ${viewMode === 'grid' ? 'active' : ''}`}
                onClick={() => setViewMode('grid')}
              >
                <FaTh /> Grid
              </button>
              <button 
                className={`view-toggle-btn-popular ${viewMode === 'list' ? 'active' : ''}`}
                onClick={() => setViewMode('list')}
              >
                <FaThList /> List
              </button>
            </div>
          </div>
        </motion.div>

        {/* Products Grid */}
        {filteredProducts.length === 0 ? (
          <motion.div 
            className="empty-state-popular"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <span className="icon">🔍</span>
            <h4 style={{ color: '#1a1a2e', fontWeight: 700 }}>No products found</h4>
            <p style={{ color: '#6b7280' }}>Try adjusting your search or filters</p>
          </motion.div>
        ) : (
          <motion.div 
            className={`row gy-4 ${viewMode === 'list' ? 'list-view' : ''}`}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            <AnimatePresence>
              {filteredProducts.map((item, index) => {
                const isSoldOut = item.stock === 0;
                const isInWishlist = wishlist.some((w) => w && w.item && w.item.id === item.id);
                const cartQty = cartItems[item.id];
                const discount = item.discount_percentage || 0;
                const rating = item.rating || 4.6;

                return (
                  <motion.div
                    key={item.id}
                    className={viewMode === 'grid' ? 'col-6 col-sm-6 col-md-4 col-lg-3' : 'col-12'}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.95 }}
                    transition={{ duration: 0.3, delay: index * 0.03 }}
                  >
                    <div className="card border-0 product-card-popular">
                      <div className="product-image-frame-popular">
                      
                        
                        <button
                          className="wishlist-btn-popular"
                          onClick={(e) => {
                            e.stopPropagation();
                            if (!wishlistLoading) toggleWishlist(item);
                          }}
                        >
                          {isInWishlist ? (
                            <FaHeart size={16} color="#5dc5fa" />
                          ) : (
                            <CiHeart size={18} color="#6b7280" />
                          )}
                        </button>

                        <img
                          src={item.item_photo || logo}
                          alt={item.title}
                          className="product-image-popular"
                          style={{ cursor: "pointer" }}
                          onClick={() => navigate(`/products/${item.id}`)}
                        />
                      </div>

                      <div className="card-body d-flex flex-column p-2 pt-3">
                        <div className={viewMode === 'list' ? 'card-body-inner' : ''}>
                          <div className={viewMode === 'list' ? 'product-info' : ''}>
                            <h6 
                              className="product-title-popular"
                              onClick={() => navigate(`/products/${item.id}`)}
                            >
                              {item.title}
                            </h6>
                            
                            {/* always render the brand line (even when empty) so every
                                card's title/price block has identical height */}
                            <div className="product-meta-popular">{item.brand || '\u00A0'}</div>

                            <div className="price-section-popular">
                              {item.item_old_price > item.item_new_price && (
                                <span className="old-price-popular">₹{item.item_old_price}</span>
                              )}
                              <span className="new-price-popular">₹{item.item_new_price}</span>
                              {discount > 0 && (
                                <span className="discount-text-popular">{discount}% OFF</span>
                              )}
                            </div>
                            
                            <div className="rating-text-popular">
                              <FaStar /> {rating} ({Math.floor(Math.random() * 100) + 50} reviews)
                            </div>
                          </div>

                          <div className={viewMode === 'list' ? 'action-section' : 'mt-auto w-100'}>
                            {cartQty && !isSoldOut && isLoggedIn ? (
                              <div className="quantity-control-popular">
                                <button 
                                  className="qty-btn-popular"
                                  onClick={() => subOne(item.id)}
                                >
                                  −
                                </button>
                                <span className="qty-display-popular">{cartQty}</span>
                                <button 
                                  className="qty-btn-popular"
                                  onClick={() => addOne(item.id)}
                                >
                                  +
                                </button>
                              </div>
                            ) : (
                              <button
                                className="add-to-cart-btn-popular"
                                onClick={() => onPressAddToCart(item.id)}
                                disabled={isSoldOut}
                              >
                                {isSoldOut ? 'Out of Stock' : 'Add to Cart'}
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                );
              })}
            </AnimatePresence>
          </motion.div>
        )}
      </div>
    </div>
  );
}

export default PopularProductsPageAll;